'use strict';

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _createClass = require('babel-runtime/helpers/create-class')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _extends = require('babel-runtime/helpers/extends')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Component = require('./Component');

var _Component2 = _interopRequireDefault(_Component);

var _reactisDatepicker = require('reactis-datepicker');

var _reactisDatepicker2 = _interopRequireDefault(_reactisDatepicker);

var _components = {
	_$DatePicker: {
		displayName: 'DatePicker'
	}
};

function _wrapComponent(uniqueId) {
	return function (ReactClass) {
		return ReactClass;
	};
}

var DatePicker = (function (_Component) {
	_inherits(DatePicker, _Component);

	function DatePicker() {
		_classCallCheck(this, _DatePicker);

		_Component.apply(this, arguments);
	}

	DatePicker.prototype.handleChange = function handleChange(value) {
		if (this.props.onChange) {
			this.props.onChange(value);
		}
	};

	DatePicker.prototype.handleBlur = function handleBlur(e) {
		if (this.props.onBlur) {
			this.props.onBlur(this.props.value);
		}
	};

	DatePicker.prototype.getError = function getError() {
		return this.props.error && this.props.error[0];
	};

	DatePicker.prototype.render = function render() {
		var _this = this;

		return _react2['default'].createElement(
			'div',
			{ className: this.getError() ? 'has-error' : "", style: { width: 215 } },
			_react2['default'].createElement(_reactisDatepicker2['default'], _extends({}, this.props, {
				value: this.props.value,
				onChange: function (value) {
					return _this.handleChange(value);
				},
				onBlur: function (e) {
					return _this.handleBlur(e);
				}
			})),
			this.getError() && _react2['default'].createElement(
				'div',
				null,
				this.getError()
			)
		);
	};

	_createClass(DatePicker, null, [{
		key: 'rules',
		value: {
			format: {
				pattern: /^(\d\d?[.]\d\d?[.]\d{4})|((\d{4})\D?(0[1-9]|1[0-2])\D?([12]\d|0[1-9]|3[01])(\D?([01]\d|2[0-3])\D?([0-5]\d)\D?([0-5]\d)?\D?(\d{3})?([zZ]|([\+-])([01]\d|2[0-3])\D?([0-5]\d)?)?)?)$/,
				message: 'Zadejte datum ve formátu d.m.RRRR!'
			},
			datetime: {
				message: 'Zadejte platné datum!'
			}
		},
		enumerable: true
	}]);

	var _DatePicker = DatePicker;
	DatePicker = _wrapComponent('_$DatePicker')(DatePicker) || DatePicker;
	return DatePicker;
})(_Component2['default']);

exports['default'] = DatePicker;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/reactis/reactis-inputs/DatePicker.js
 ** module id = 1032
 ** module chunks = 1
 **/